import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { DISTANCE_SOURCE_TAG, TAG_META } from './constants';
import { formatKm } from './format';

const { Text } = Typography;
const STAGE_CAPTION = {
	final: 'Final Distance used for billing',
	ended: 'Distance at trip end — billing uses this at closure',
	running: 'Distance so far — billing uses this at closure',
};

/**
 * The verdict panel that sits to the right of the reconciliation rows: which source won,
 * and the single number billing will use.
 *
 * It repeats a figure the rows also carry, deliberately — Ops open this tab to read one tag
 * and one number, and making them scan a table for it is how the old card lost their trust.
 */
function DistanceSourceTagPanel({ model }) {
	const { tag, distances, distanceStage } = model;
	const meta = TAG_META[tag.code] || TAG_META[DISTANCE_SOURCE_TAG.NO_SOURCE];

	return (
		<div
			style={{
				background: '#f8fafc',
				borderRadius: 12,
				padding: '24px 20px',
				textAlign: 'center',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				gap: 12,
			}}
		>
			<Text style={{ fontSize: 13, color: '#64748b' }}>Distance Source Tag</Text>

			<div>
				<span
					style={{
						display: 'inline-flex',
						alignItems: 'center',
						gap: 8,
						background: meta.background,
						border: `1px solid ${meta.border}`,
						color: meta.color,
						borderRadius: 999,
						padding: '6px 16px',
						fontSize: 14,
						fontWeight: 600,
					}}
				>
					<span
						style={{
							width: 8,
							height: 8,
							borderRadius: '50%',
							background: meta.dot,
						}}
					/>
					{tag.label || meta.label}
				</span>
			</div>

			{tag.provisional && (
				<Tooltip title="GPS coverage has not been measured for this trip yet, so this tag is derived from the distance source alone. It will firm up once GPS health data is available.">
					<Text style={{ fontSize: 11, color: '#94a3b8' }}>
						provisional <InfoCircleOutlined />
					</Text>
				</Tooltip>
			)}

			{tag.unverifiable && (
				<Tooltip title="This trip closed before GPS reconciliation existed, so its coverage was never measured and cannot be backfilled. The distance itself is final — only the GPS verification behind it is missing.">
					<Text style={{ fontSize: 11, color: '#94a3b8' }}>
						not GPS-verified <InfoCircleOutlined />
					</Text>
				</Tooltip>
			)}

			<Text strong style={{ fontSize: 40, lineHeight: 1.1, color: '#0f172a' }}>
				{formatKm(distances.finalKm)}
			</Text>

			<Text style={{ fontSize: 13, color: '#64748b' }}>{STAGE_CAPTION[distanceStage]}</Text>
		</div>
	);
}

DistanceSourceTagPanel.propTypes = {
	model: PropTypes.object.isRequired,
};

export default DistanceSourceTagPanel;
